import axios from 'axios'
import { loginUrl } from '@/setting'
import { message } from 'ant-design-vue'

// 创建一个 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL, // 所有的请求地址前缀部分
  timeout: 60000, // 请求超时时间毫秒
  withCredentials: true, // 异步请求携带cookie
  headers: {
    // 设置后端需要的传参类型
    // Authorization: 'Bearer <TOKEN>'
  }
})

// 添加请求拦截器
service.interceptors.request.use(
  function (config) {
    // 在发送请求之前做些什么

    if (config.url_type === "stat") {
      config.baseURL = process.env.VUE_APP_STAT_BASE_URL;
    } else if (config.url_type === "deimos") {
      config.baseURL = process.env.VUE_APP_DEIMOS_BASE_URL;
    }

    return config
  },
  function (error) {
    // 对请求错误做些什么
    // console.log(error)
    return Promise.reject(error)
  }
)

const errorConfig = {
  401: '请登录后操作'
}

const errorHandle = (error, errorStatus) => errorConfig[errorStatus] || `连接错误${error.response.status}`

// 添加响应拦截器
service.interceptors.response.use(
  function (response) {
    // console.log(response)
    // 2xx 范围内的状态码都会触发该函数。
    // 对响应数据做点什么
    // dataAxios 是 axios 返回数据中的 data
    const dataAxios = response.data
    // 这个状态码是和后端约定的
    // const code = dataAxios.reset
    return dataAxios
  },
  function (error) {
    // 超出 2xx 范围的状态码都会触发该函数。
    // 对响应错误做点什么
    if (error && error.response.status) {
      error.msg = errorHandle(error, error.response.status)
    }
    if (error && error.response.status === 401) {
      message.error(error.msg)
      location.href = loginUrl
    }
    // console.log(error)
    return Promise.reject(error)
  }
)

export default service
